import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import _ from "lodash"

import Loading from "../../../common/Loading"
import CommonApprovalDisplay from "../../../common/CommonApprovalDisplay"

import { insertApprovalInstances } from "../../../services/api/approvalInstances"

import { raiseToast } from "../../../services/redux/reducers/toast/toast"

import { getApprovalParams, round, getApproverDetails } from "../../../utils"
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig"


const NewApprovalsDisplay = (props) => {
    const {
        buyerQuote,
        buyerQuoteItems,
        approvalInstances,
        quotationApprovals,
        approvalTypes,
        materialDetails,
        approvalRequestStatusDetails,
        setApprovalRequestStatusDetails,
        brandData,
        materialCategories,
        buyerReqItems,
        isDoc,
        handleRemarks,
        handleApprovalRequest,
        buyerQuoteId,
        buyerReq,
        approvalSecondary
    } = props

    const [raiseReqLoading, setRaiseReqLoading] = useState(false)

    const dispatch = useDispatch()
    const userDetails = useSelector((state) => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)
    let currencyShortName = pmCompanyConfig.currencyShortName

    const handleApprovalRemarks = (id, text, prefillText) => {
        handleRemarks(id, text, prefillText)
    }

    const handleApproverChange = (srNo, userId) => {
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if (eachRequestDetail.srNo === srNo) {
                return { ...eachRequestDetail, notifyToUserId: userId }
            }
            return eachRequestDetail
        })

        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const getSellerUnitPrice = (relatedBuyerQuoteItems) => {
        let totalUnitPrice = 0
        let qty = 0
        relatedBuyerQuoteItems.forEach(eachQuoteItem => {
            if(parseFloat(eachQuoteItem.bQuotSellerQty) > 0){
                totalUnitPrice += round(parseFloat(eachQuoteItem.bQuotSellerQty) * parseFloat(eachQuoteItem.bQuotSellerPrice))
                qty += parseFloat(eachQuoteItem.bQuotSellerQty)
            }
        })
        return round(totalUnitPrice / qty, 2)
    }

    const getItemProfit = (sellerUnitPrice, buyerUnitPrice, qty) => {
        const profit = round(buyerUnitPrice*qty - sellerUnitPrice*qty , 2)
        const profitPerc = round((profit / (sellerUnitPrice*qty))*100, 2)

        return {profit, profitPerc}
    }

    const getProfit = (relatedBuyerQuoteItems) => {
        let totalSellersPrice = 0
        relatedBuyerQuoteItems?.forEach(eachBuyerQuoteItem => {
            let beforeTax = 0
            let totalTax = 0
            let totalPrice = 0
    
            if (eachBuyerQuoteItem.bQuotSellerQty) {
                let bQuotSellerQuantity =  round(eachBuyerQuoteItem.bQuotSellerQty)
                beforeTax = round(bQuotSellerQuantity * eachBuyerQuoteItem.bQuotSellerPrice)
                totalPrice = beforeTax
                totalTax = 0
    
                if (eachBuyerQuoteItem.bQuotSellerGSTRate) {
                    totalTax = round(eachBuyerQuoteItem.bQuotSellerGSTRate * beforeTax * 0.01)
                    totalPrice = totalTax + beforeTax
                }
            }
            totalSellersPrice += totalPrice
        })
        let profit = round(relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax - totalSellersPrice)
        profit = profit && profit

        return profit
    }

    const handleRaiseReq = async (displayApproval) => {
        if(!displayApproval.remarks){
            return dispatch(raiseToast({severity:'error', detail: "Please enter remarks!", life: 3000}))
        }

        const relatedApproval = quotationApprovals.find(eachApproval => eachApproval.approvalId === displayApproval.approvalId)
        if (relatedApproval.config?.isUploadFileMandatory && !displayApproval.uploadFile){
            return dispatch(raiseToast({severity:'error', detail: "Please Upload document!", life: 3000}))
        }

        setRaiseReqLoading(true)
        const newApprovalReq = {
            ...displayApproval, 
            approvalInstanceId: undefined, 
            statusId: 12, 
            docNo: buyerQuote.docNo, 
            parentDocNo: buyerReq.docNo, 
            buyerCompanyId: buyerQuote.companyId, 
            docTypeId: 13, docId: buyerQuoteId, 
            branchId: buyerQuote.pmBranchId, 
            createdBy: userDetails.userId,
            approvedMetrics: {amount: parseFloat(displayApproval.approvedMetrics?.amount)},
            uploadFile: displayApproval.uploadFile,
            processedBy: null,
            processedAt: null,
            processedRemarks: null
        }

        const newApprovalInstanceRes = await insertApprovalInstances({ requestedApprovals: [newApprovalReq] })
        if(newApprovalInstanceRes.failure){
            setRaiseReqLoading(false)
            return dispatch(raiseToast({severity:'error', summary:'newApprovalInstanceRes', detail: newApprovalInstanceRes.data.error, life: 3000}))
        }
        setRaiseReqLoading(false)

        handleApprovalRequest({...newApprovalInstanceRes.data[0], srNo: displayApproval.srNo, requestStatus: "REQUESTED"})
    }

    const getApprovalBody = (approvalTypeId, products, eachRequestDetail, relatedQuotationApproval, activeBuyerReqItems) => {
        let lossRelatedBuyerReqItems = []
        switch (approvalTypeId){
            case 1: // >1Lac
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote?.bQuotTotalPOTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 2: //Loss
                lossRelatedBuyerReqItems = activeBuyerReqItems.filter(eachReqItem => {
                    const relatedBuyerQuotes = buyerQuoteItems.filter(eachBuyerQuote => eachBuyerQuote.buyerReqItemId === eachReqItem.buyerReqItemId)
                    const amount = getProfit(relatedBuyerQuotes)
                    if(amount < 0){
                        return true
                    }
                    return false
                })

                if(lossRelatedBuyerReqItems.length === 0) return null

                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">S.No</th>
                                    <th className="">PRODUCTS</th>
                                    <th className="">SPECIFICATION</th>
                                    <th className="">BUYER UNIT PRICE</th>
                                    <th className="">QUANTITY</th>
                                    <th className="">TOTAL PRICE</th>
                                    <th className="">LOSS</th>
                                    {/* <th className="custom-th">PROFIT PERCENTAGE</th> */}
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                {
                                    lossRelatedBuyerReqItems.map((eachReqItem, index) => {
                                        const relatedBuyerQuoteItem = buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)
                                        const relatedMaterialDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachReqItem.materialId)

                                        const relatedBuyerQuotes = buyerQuoteItems.filter(eachBuyerQuote => eachBuyerQuote.buyerReqItemId === eachReqItem.buyerReqItemId)
                                        const profitAmount = getProfit(relatedBuyerQuotes)

                                        return (
                                            <tr key={`buyerReqItem-${eachReqItem.buyerReqItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="">{index + 1}</td>
                                                <td className="">{relatedMaterialDetails.productName}</td>
                                                <td className="">{relatedMaterialDetails.productSpecification}</td>
                                                <td className="">{relatedBuyerQuoteItem.bQuotUnitPrice}</td>
                                                <td className="">{relatedBuyerQuoteItem.totReqQty}</td>
                                                <td className="">{currencyShortName}.{relatedBuyerQuoteItem?.bQuoteItemAmountWithTax}</td>
                                                <td className="">{currencyShortName}.{profitAmount}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 3: //brand
                const { brand_id } = getApprovalParams(relatedQuotationApproval)
                const brandRelatedBuyerReqItems = activeBuyerReqItems.filter(eachBuyerReqItem => eachBuyerReqItem?.brandId === brand_id)
                const relatedBrandMaterialIds = brandRelatedBuyerReqItems.map(eachReqItem => eachReqItem.materialId)
                const allBrandRelatedMaterialDetails = materialDetails.filter(eachMaterial => relatedBrandMaterialIds.includes(eachMaterial.materialId))
                const brandDetails = brandData.find(eachBrand => eachBrand.brandId === allBrandRelatedMaterialDetails?.[0].brandId)

                if(brandRelatedBuyerReqItems.length === 0) return null
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">S.No</th>
                                    <th className="">MATERIAL ID</th>
                                    <th className="">PRODUCTS</th>
                                    <th className="">SPECIFICATION</th>
                                    <th className="">BUYER UNIT PRICE</th>
                                    <th className="">QUANTITY</th>
                                    <th className="">TOTAL PRICE</th>
                                    <th className="">PROFIT</th>
                                    {/* <th className="custom-th">PROFIT PERCENTAGE</th> */}
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                {
                                    brandRelatedBuyerReqItems.map((eachReqItem, index) => {
                                        const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuote => eachBuyerQuote.buyerReqItemId === eachReqItem.buyerReqItemId)
                                        const profitAmount = getProfit(relatedBuyerQuoteItems)

                                        const relatedMaterialBrandDetails =  allBrandRelatedMaterialDetails.find(eachBrandDet => eachBrandDet.materialId === eachReqItem.materialId)

                                        return (
                                            <tr key={`buyerReqItem-${eachReqItem.buyerReqItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="">{index + 1}</td>
                                                <td className="">{relatedMaterialBrandDetails.materialId}</td>
                                                <td className="">{relatedMaterialBrandDetails.productName}</td>
                                                <td className="">{relatedMaterialBrandDetails.productSpecification}</td>
                                                <td className="">{relatedBuyerQuoteItems?.[0]?.bQuotUnitPrice}</td>
                                                <td className="">{relatedBuyerQuoteItems?.[0]?.totReqQty}</td>
                                                <td className="">{currencyShortName}.{relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax ? relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax : ''}</td>
                                                <th className="">{currencyShortName}.{profitAmount}</th>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 4: //Category
                const { category_ids } = getApprovalParams(relatedQuotationApproval)
                const categoryRelatedBuyerReqItems = activeBuyerReqItems.filter(eachBuyerReqItem => category_ids.includes(eachBuyerReqItem?.categoryId))
                const categoryRelatedMaterialIds = categoryRelatedBuyerReqItems.map(eachReqItem => eachReqItem.materialId)

                const categoryRelatedMaterialDetails = materialDetails.filter(eachMaterial => categoryRelatedMaterialIds.includes(eachMaterial.materialId))
                const categoryDetails = materialCategories.find(eachcategory => eachcategory.categoryId === categoryRelatedMaterialDetails?.[0]?.categoryId)

                if(categoryRelatedBuyerReqItems.length === 0) return null
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">S.No</th>
                                    <th className="">MATERIAL ID</th>
                                    <th className="">PRODUCTS</th>
                                    <th className="">SPECIFICATION</th>
                                    <th className="">SELLER UNIT PRICE</th>
                                    <th className="">BUYER UNIT PRICE</th>
                                    <th className="">QUANTITY</th>
                                    <th className="">TOTAL PRICE</th>
                                    <th className="">PROFIT</th>
                                    <th className="">PROFIT PERCENTAGE</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                {
                                    categoryRelatedBuyerReqItems.map((eachReqItem, index) => {
                                        const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)
                                        const relatedMaterialDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachReqItem.materialId)

                                        const sellerUnitPrice = getSellerUnitPrice(relatedBuyerQuoteItems)
                                        const {profit, profitPerc} = getItemProfit(sellerUnitPrice, relatedBuyerQuoteItems?.[0]?.bQuotUnitPrice, relatedBuyerQuoteItems?.[0]?.totReqQty)
                                        console.log("profit, profit perc", profit, profitPerc)

                                        return (
                                            <tr key={`buyerReqItem-${eachReqItem.buyerReqItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="">{index + 1}</td>
                                                <td className="">{relatedMaterialDetails.materialId}</td>
                                                <td className="">{relatedMaterialDetails.productName}</td>
                                                <td className="">{relatedMaterialDetails.productSpecification}</td>
                                                <td className="">{sellerUnitPrice}</td>
                                                <td className="">{relatedBuyerQuoteItems?.[0]?.bQuotUnitPrice}</td>
                                                <td className="">{relatedBuyerQuoteItems?.[0]?.totReqQty}</td>
                                                <td className="">{currencyShortName}.{relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax}</td>
                                                <td className="">{currencyShortName}.{profit}</td>
                                                <td className="">{profitPerc}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 5: //Best Seller
                const relatedMaterialDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachRequestDetail.materialId)
                const relatedBestSellerQuoteItem = buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.statusId !== 2 && eachBuyerQuoteItem.materialId === eachRequestDetail.materialId)

                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCT</th>
                                    <th className="">PRODUCT SPECIFICATION</th>
                                    <th className="">AVG SELLER PRICE</th>
                                    <th className="">AVG BEST SELLER PRICE</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{relatedMaterialDetails.productName}</td>
                                    <td className="">{relatedMaterialDetails.productSpecification}</td>
                                    <td className="">{currencyShortName}.{relatedBestSellerQuoteItem.avgSellerPrice}</td>
                                    <td className="">{currencyShortName}.{relatedBestSellerQuoteItem.bestAvgSellerPrice}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 6: //Logistics
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="custom-th">TOTAL TAX</th>
                                    <th className="custom-th">LOGISTICS GST</th>
                                    <th className="custom-th">MAX PRODUCTS GST</th>
                                    <th className="custom-th">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="custom-td">{"Logistics Charge"}</td>
                                    <td className="custom-td">{currencyShortName}.{buyerQuote.bQuotLogisticsBeforeTax}</td>
                                    <td className="custom-td">{currencyShortName}.{round(buyerQuote.bQuotLogisticsBeforeTax * buyerQuote.bQuotLogisticsGSTRate * 0.01)}</td>
                                    <td className="custom-td">{buyerQuote.bQuotLogisticsGSTRate}%</td>
                                    <td className="custom-td">{buyerQuote.maxLogisticGSTRate}%</td>
                                    <td className="custom-td">{currencyShortName}.{buyerQuote.bQuotLogisticsWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 10: //Projects
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">REQUIREMENT TYPE</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{"Projects"}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 12: // >5Lac
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote?.bQuotTotalPOTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 13: // >10Lac
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote?.bQuotTotalPOTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 28:
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote?.bQuotTotalPOTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 38: 
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote?.bQuotTotalPOTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 39:
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote?.bQuotTotalPOTax}</td>
                                    <td className="">{currencyShortName}.{buyerQuote.bQuotTotalItemAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 40: //Loss
                lossRelatedBuyerReqItems = activeBuyerReqItems.filter(eachReqItem => {
                    const relatedBuyerQuotes = buyerQuoteItems.filter(eachBuyerQuote => eachBuyerQuote.buyerReqItemId === eachReqItem.buyerReqItemId)
                    const amount = getProfit(relatedBuyerQuotes)
                    if(amount < 0){
                        return true
                    }
                    return false
                })

                if(lossRelatedBuyerReqItems.length === 0) return null

                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">S.No</th>
                                    <th className="">PRODUCTS</th>
                                    <th className="">SPECIFICATION</th>
                                    <th className="">BUYER UNIT PRICE</th>
                                    <th className="">QUANTITY</th>
                                    <th className="">TOTAL PRICE</th>
                                    <th className="">LOSS</th>
                                    {/* <th className="custom-th">PROFIT PERCENTAGE</th> */}
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                {
                                    lossRelatedBuyerReqItems.map((eachReqItem, index) => {
                                        const relatedBuyerQuoteItem = buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)
                                        const relatedMaterialDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachReqItem.materialId)

                                        const relatedBuyerQuotes = buyerQuoteItems.filter(eachBuyerQuote => eachBuyerQuote.buyerReqItemId === eachReqItem.buyerReqItemId)
                                        const profitAmount = getProfit(relatedBuyerQuotes)

                                        return (
                                            <tr key={`buyerReqItem-${eachReqItem.buyerReqItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="">{index + 1}</td>
                                                <td className="">{relatedMaterialDetails.productName}</td>
                                                <td className="">{relatedMaterialDetails.productSpecification}</td>
                                                <td className="">{relatedBuyerQuoteItem.bQuotUnitPrice}</td>
                                                <td className="">{relatedBuyerQuoteItem.totReqQty}</td>
                                                <td className="">{currencyShortName}.{relatedBuyerQuoteItem?.bQuoteItemAmountWithTax}</td>
                                                <td className="">{currencyShortName}.{profitAmount}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                )
                break
            default:
                return null
        }
    }

    const renderApprovals = (buyerQuoteItems, approvalInstances, quotationApprovals, approvalRequestStatusDetails) => {
        const activeBuyerReqItems = buyerReqItems.filter(eachBuyerReqItem => eachBuyerReqItem.statusId === 1)

        const pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []
        const pmCompanyRoles = userDetails?.PMCompanyDetails?.companyRoles ? userDetails?.PMCompanyDetails?.companyRoles : []
        const pmBranches = userDetails?.PMCompanyDetails?.companyBranches ? userDetails?.PMCompanyDetails?.companyBranches : []

        const updatedApprovalInstances = approvalInstances.map(eachApprovalInstance => {
            const relatedApproval = quotationApprovals.find(eachQuoteApproval => eachQuoteApproval.approvalId === eachApprovalInstance.approvalId)
            eachApprovalInstance = {...eachApprovalInstance, approvalTypeId: relatedApproval.approvalTypeId}
            return eachApprovalInstance
        })

        return approvalRequestStatusDetails.map((eachRequestDetail, index) => {
            const relatedQuotationApproval = quotationApprovals.find(eachQuoteApproval => eachQuoteApproval.approvalId === eachRequestDetail.approvalId)
            const relatedApprovalType = approvalTypes.find(eachApprovalType => eachApprovalType.approvalTypeId === relatedQuotationApproval.approvalTypeId)

            let createdBy = ""
            let approvedOrRejectedBy = ""
            if(["REJECTED", "APPROVED"].includes(eachRequestDetail.requestStatus)){
                approvedOrRejectedBy = pmCompanyUsers.find(eachUser => eachUser.userId === eachRequestDetail.processedBy)
            }

            const products = []
            buyerReqItems.map(eachReqItem => {
                materialDetails.forEach(eachMaterial => {
                    if (eachReqItem.materialId === eachMaterial.materialId) {
                        products.push(eachMaterial.productName)
                    }
                })
            })

            createdBy = eachRequestDetail.createdBy ? eachRequestDetail.createdBy : userDetails?.userId
            const primaryApprover = getApproverDetails(relatedQuotationApproval, buyerQuote.pmBranchId, createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary)

            let relatedHistoryRequests = updatedApprovalInstances.filter(eachReq => eachReq.approvalId === relatedQuotationApproval.approvalId && eachReq.approvalInstanceId && eachReq.approvalInstanceId !== eachRequestDetail.approvalInstanceId)
            let approvalBody = getApprovalBody(relatedQuotationApproval.approvalTypeId, products, eachRequestDetail, relatedQuotationApproval, activeBuyerReqItems)

            return (
                <CommonApprovalDisplay
                    approvalBody={approvalBody}
                    index={index}
                    approvalType={relatedApprovalType}
                    approval={relatedQuotationApproval}
                    isDoc={isDoc}
                    handleRaiseReq={handleRaiseReq}
                    handleApprovalRemarks={handleApprovalRemarks}
                    handleApproverChange={handleApproverChange}
                    primaryApprover={primaryApprover}
                    eachRequestDetail={eachRequestDetail}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    historyRequests={relatedHistoryRequests}
                    approvedOrRejectedBy={approvedOrRejectedBy}
                />
            )
        })
    }

    return (
        <div className="approval-modal">
            <Loading visible={raiseReqLoading} />
            {renderApprovals(buyerQuoteItems, approvalInstances, quotationApprovals, approvalRequestStatusDetails)}
        </div>
    )
}

export default NewApprovalsDisplay